module.exports = __webpack_public_path__ + "static/img/figma-dev-mode.b79e798c.png";